import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { selectCollectionsList } from 'src/features/common/collection/ducks/list/list.selectors';
import { fetchCollectionsByIdsThunk } from 'src/features/common/collection/ducks/list/list.thunk';

export function useFetchCollectionsList() {
    const dispatch = useAppDispatch();
    const  listEntities = useCollectionsListEntities();

    return useCallback(async ({ ids } : { ids?: string[] }) => {
        const filteredList = ids?.filter(item => !listEntities[item]) ?? [];

        if (filteredList.length) {
            clearTimeout(useFetchCollectionsList.fetchListRef);
            useFetchCollectionsList.fetchList.ids = [...new Set([
                ...useFetchCollectionsList.fetchList.ids,
                ...filteredList
            ])];
            useFetchCollectionsList.fetchListRef = setTimeout(async () => {
                if (useFetchCollectionsList.fetchList.ids.length) {
                    await dispatch(fetchCollectionsByIdsThunk(
                        useFetchCollectionsList.fetchList.ids
                    ));
                    useFetchCollectionsList.fetchList.ids = [];
                }
            });
        }
    }, [dispatch, listEntities]);
}

useFetchCollectionsList.fetchList = {
    ids: [] as string[],
};
useFetchCollectionsList.fetchListRef = null as any;

export const useCollectionsListEntities = () => useAppSelector(selectCollectionsList);
